import { useMemo } from 'react';

import ErrorState from '@zenbusiness/zui/ErrorState';

import { useQASession } from '#client/hooks/useQASession';
import { useWebinars } from '#client/hooks/useWebinars';

import GettingStarted from './GettingStarted';
import GettingStartedSkeleton from './GettingStartedSkeleton';
import { classifyWebinar } from '../helpers';

function GettingStartedWrapper() {
  const {
    data: webinars, loading, error, refetch
  } = useWebinars();

  const {
    data: qaSection, loading: qaLoading, error: qaError, refetch: qaRefetch
  } = useQASession();

  const { moreWebinars, blueprints } = useMemo(
    () => classifyWebinar(webinars),
    [webinars]
  );

  if (loading || qaLoading) {
    return <GettingStartedSkeleton />;
  }

  if (error) {
    return <ErrorState onReload={refetch} />;
  }

  if (qaError) {
    return <ErrorState onReload={qaRefetch} />;
  }

  return (
    <GettingStarted
      qaSection={qaSection}
      webinars={webinars}
      moreWebinars={moreWebinars}
      blueprints={blueprints}
    />
  );
}

export default GettingStartedWrapper;
